import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/cost-items`;

const getAuthToken = () => localStorage.getItem('token');

const getConfig = (params) => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`,
    'Content-Type': 'application/json',
  },
  ...(params ? { params } : {}),
});

export const getCostItems = async ({ active = true, includeInactive = false, category } = {}) => {
  const params = {};
  if (active && !includeInactive) params.active = 'true';
  if (includeInactive) params.includeInactive = '1';
  if (category) params.category = category;
  const response = await axios.get(API_URL, getConfig(params));
  return response.data;
};

export const getCostItemById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`, getConfig());
  return response.data;
};

export const createCostItem = async (payload) => {
  const response = await axios.post(API_URL, payload, getConfig());
  return response.data;
};

export const updateCostItem = async (id, payload) => {
  const response = await axios.put(`${API_URL}/${id}`, payload, getConfig());
  return response.data;
};

export const deleteCostItem = async (id, { hard = false } = {}) => {
  const params = hard ? { hard: '1' } : undefined;
  const response = await axios.delete(`${API_URL}/${id}`, getConfig(params));
  return response.data;
};
